import router from "@/router";
import axios from "axios";
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import { localCache } from "@/utils/Cache";
import { delCookie } from "@/utils/delCookie";
import qs from "qs";
import menu from "@/store/menu";
import { getCookie } from "@/utils/getCookie";
import store from "@/store";

axios.defaults.headers.get["Content-Type"] =
  "application/x-www-form-urlencoded";
// axios.defaults.withCredentials = true;
let ajaxElVm = null;
let hit = 0;
let isShow = false;
// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    hit++;
    config.headers["satoken"] = getCookie("sccp_platform");
    if (hit === 1 && !ajaxElVm) {
      ajaxElVm = ElNotification({
        lock: true,
        duration: 0,
        message: "数据请求中...",
        iconClass: "el-icon-loading",
        customClass: "el-notify--ajax",
        background: "rgba(0,0,0, 0.3)",
        position: "bottom-right",
      });
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
// 响应拦截器
axios.interceptors.response.use(
  (res) => {
    hit--;
    if (res.data && res.config?.responseType == "blob") {
      if (res.data.type === "application/json") {
        const reader = new FileReader();
        reader.readAsText(res.data, "utf-8");
        reader.onload = function () {
          const _res = JSON.parse(reader.result);
          if (_res.code == 500) {
            ElMessage.error(_res.msg);
            return Promise.reject(_res.msg);
          }
          // 此处为接口返回值
        };
      }
      return res;
    }
    setTimeout(() => {
      if (hit === 0 && ajaxElVm) {
        ajaxElVm.close();
        ajaxElVm = null;
      }
    }, 800);
    if (res.data.code === 500 || res.data.code == 123) {
      ElMessage.error(res.data.msg);
      return Promise.reject(res.data.msg);
    } else if (res.data.code == 401) {
      ElMessage.error(res.data.msg);
    } else if (res.data.code === 501) {
      if (!isShow) {
        isShow = true;
        delCookie();
        sessionStorage.clear();
        ElMessage({
          type: "error",
          message: "登陆已过期,请重新登录!",
          duration: 3000,
          offset: 200,
          customClass: "logoutClass",
          onClose() {
            isShow = false;
            router.push("/login");
          },
        });
        // ElMessageBox.confirm("登陆已过期,请重新登录", "系统提示", {
        //   confirmButtonText: "确认",
        //   cancelButtonText: "取消",
        //   type: "warning",
        // })
        //   .then(() => {
        //     isShow = true;
        //     const userData =
        //       localCache.getCache("userData") &&
        //       JSON.parse(localCache.getCache("userData"));
        //     // 初始平台
        //     router.push("/login");
        //     delCookie();
        //     sessionStorage.clear();
        //   })
        //   .catch(() => {
        //     isShow = false;
        //   });
      }
    } else if (res.data.code == 505) {
      ElMessageBox.confirm("您已被挤下线啦，请重新登录", "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 美视电影学院
          window.open(store.state.menu.ownUrl + "#/login", "_self");
          delCookie();
          localCache.clearCache();
        })
        .catch(() => {});
    } else if (res.data.code == 101) {
      router.push({ path: "/error" });
    } else if (res.data.code == 199) {
      router.push({ path: "/noperssion" });
    } else if (res.data.code == 200) {
      return res.data;
    } else {
      ElMessage.error(res.data.msg);
      return Promise.reject(res.data.msg);
    }
  },
  (err) => {
    hit--;
    setTimeout(() => {
      if (hit === 0 && ajaxElVm) {
        ajaxElVm.close();
        ajaxElVm = null;
      }
    }, 800);
    ElMessage.error(err.response.data.msg);
    return Promise.reject(err);
  }
);
export default axios;
